import React from 'react'
import { CheckCircleFilled } from '@ant-design/icons'
import { Steps } from 'antd'
import RadarIcon from '../../RadarIcon'
import { WAIT, PROCESS, FINISH } from '../constants'
import { getCurrent } from '../parcers'
import StepDescription from './StepDescription'
import { StepTypeNames } from '../../../../refactory/modules/jobs/domain/task'

const progressDot =
  (primaryColor) =>
  (defaultElement, { status }) => {
    const iconParams = { height: 32, width: 32, fontSize: 32, color: primaryColor }
    const finishState = status === FINISH && <CheckCircleFilled style={iconParams} />
    const processState = status === PROCESS && <RadarIcon style={iconParams} />
    const waitState = status === WAIT && <div className='wait-state-dot' />
    return finishState || processState || waitState
  }

const StepsAdvance = (steps) => (primaryColor) => (locale) => {
  const showStep = (active, type) => !(type?.name === StepTypeNames.BACK_TO_STORE && !active)

  return (
    <Steps
      direction='vertical'
      className='resource-steps-advance'
      current={getCurrent(steps)}
      progressDot={progressDot(primaryColor)}
    >
      {steps.map(({ name, actualStart, optimalStart, optimalEnd, status, actualEnd, uuid, active, type }) => {
        const stepParams = {
          description: StepDescription({
            title: name.toLocaleLowerCase(),
            started: actualStart,
            optimalStart: optimalStart,
            optimalEnd: optimalEnd,
            ended: actualEnd,
            color: primaryColor,
            locale,
            status
          }),
          key: uuid
        }
        return showStep(active, type) ? <Steps.Step key={uuid} {...stepParams} /> : null
      })}
    </Steps>
  )
}
export default StepsAdvance
